<nav class="navbar relative">
  @if (isAuthenticated()) {
    <div class="flex">
      <button
        [routerLink]="RouteNames.MAIN_PAGE"
        tuiButton
        appearance="mono"
        size="m"
      >
        COME ON
      </button>
      <app-division-select></app-division-select>
    </div>
  } @else {
    <button
      [routerLink]="RouteNames.MAIN_PAGE"
      tuiButton
      appearance="mono"
      size="m"
    >
      <div class="flex">COME ON</div>
    </button>
  }

  @if (isAuthenticated()) {
    <div class="absolute left-1/2 -translate-x-1/2 w-max">
      @for (item of availableMenuItems(); track $index) {
        <button
          (click)="navigate(item)"
          tuiButton
          appearance="mono"
          size="m"
          type="button"
        >
          {{ item.name | transloco }}
        </button>
      }

      <app-dropdown-menu></app-dropdown-menu>
    </div>
  }

  <div class="flex gap-x-2">
    <app-language-select></app-language-select>
    @if (isAuthenticated()) {
      <app-user-menu></app-user-menu>
    } @else {
      <button
        tuiIconButton
        appearance="outline"
        size="m"
        type="button"
        icon="tuiIconLogIn"
        [routerLink]="RouteNames.LOGIN_PAGE"
      ></button>
    }
  </div>
</nav>
